import { render, staticRenderFns } from "./BannerListLink.vue?vue&type=template&id=2d29af84&scoped=true&"
import script from "./BannerListLink.vue?vue&type=script&lang=js&"
export * from "./BannerListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29af84",
  null
  
)

export default component.exports